import { TICKS_PER_BAR, TICKS_PER_BEAT } from '../../shared/tempo';
import type { ClassDefinition, UpgradeDefinition } from '../types';

export interface ClubsAttack {
  kind: 'clubs';
  clubs: number;
  damage: number;
  cooldownTicks: number;
  speed: number;
  radius: number;
  rangeTicks: number;
  pierce: number;
  catchRadius: number;
  returnBars: number;
  returnSpeed: number;
  catchOnBeatTicks: number;
  onBeatMul: number;
}

export interface CascadeEffect {
  kind: 'cascade';
  damage: number;
  bounces: number;
  range: number;
  speed: number;
}

const CLUBS = 3;

export const JONGLEUR: ClassDefinition = {
  id: 'jongleur',
  name: 'Le Jongleur',
  role: 'Lance ses trois massues et court les ramasser, en rythme.',
  color: '#f7c948',
  maxHp: 120,
  speed: 7.8,
  radius: 14,
  pickupRadius: 100,
  attack: {
    kind: 'clubs',
    clubs: CLUBS,
    damage: 20,
    cooldownTicks: TICKS_PER_BEAT,
    speed: 13,
    radius: 8,
    rangeTicks: 15,
    pierce: 2,
    catchRadius: 48,
    returnBars: 2,
    returnSpeed: 24,
    catchOnBeatTicks: 2,
    onBeatMul: 2,
  },
  skill: {
    id: 'cascade',
    name: 'Cascade',
    description:
      'Toutes tes massues partent d’un coup, rebondissent de bad vibe en bad vibe et te reviennent.',
    cooldownTicks: 3 * TICKS_PER_BAR,
    effect: { kind: 'cascade', damage: 20, bounces: 7, range: 260, speed: 20 },
  },
  gauge: { kind: 'clubs', name: 'Massues', max: CLUBS, start: CLUBS },
  affinityWeaponIds: ['diabolo'],
};

export const JONGLEUR_UPGRADES: readonly UpgradeDefinition[] = [
  {
    id: 'massues-lestees',
    name: 'Massues lestées',
    description: 'Tes massues traversent une bad vibe de plus.',
    family: 'class',
    classId: 'jongleur',
    modifiers: [{ stat: 'pierceAdd', add: 1 }],
    rarities: {
      rare: {
        description: 'Tes massues traversent deux bad vibes de plus.',
        modifiers: [{ stat: 'pierceAdd', add: 2 }],
      },
      legendary: {
        description: 'Tes massues traversent trois bad vibes de plus.',
        modifiers: [{ stat: 'pierceAdd', add: 3 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'lancer-d-epaule',
    name: 'Lancer d’épaule',
    description: 'Tes massues volent plus vite et plus loin.',
    family: 'class',
    classId: 'jongleur',
    modifiers: [{ stat: 'projectileSpeedMul', mul: 1.3 }],
    rarities: {
      rare: {
        description: 'Tes massues volent nettement plus vite et plus loin.',
        modifiers: [{ stat: 'projectileSpeedMul', mul: 1.6 }],
      },
      legendary: {
        description: 'Tes massues volent deux fois plus vite et plus loin.',
        modifiers: [{ stat: 'projectileSpeedMul', mul: 2 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'grande-cascade',
    name: 'Grande cascade',
    description: 'Ta cascade frappe plus fort.',
    family: 'class',
    classId: 'jongleur',
    modifiers: [{ stat: 'skillPowerMul', mul: 1.55 }],
    rarities: {
      rare: {
        description: 'Ta cascade frappe deux fois plus fort.',
        modifiers: [{ stat: 'skillPowerMul', mul: 2.25 }],
      },
      legendary: {
        description: 'Ta cascade frappe trois fois plus fort.',
        modifiers: [{ stat: 'skillPowerMul', mul: 3 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'cascade-continue',
    name: 'Cascade continue',
    description: 'Ta cascade revient plus vite.',
    family: 'class',
    classId: 'jongleur',
    modifiers: [{ stat: 'skillCooldownMul', mul: 0.64 }],
    rarities: {
      rare: {
        description: 'Ta cascade revient bien plus vite.',
        modifiers: [{ stat: 'skillCooldownMul', mul: 0.36 }],
      },
      legendary: {
        description: 'Ta cascade revient presque en continu.',
        modifiers: [{ stat: 'skillCooldownMul', mul: 0.16 }],
      },
    },
    maxStacks: 2,
  },
];
